import { createContext } from 'react';
import { User } from '../../Types/User';

export interface AuthContextApi {
  isAuthenticated: boolean;
  setToken: (token: string) => void;
  logout: () => void;
  getUser: () => Promise<User | undefined>;
  user: User | undefined;
  isPartner: boolean;
  isExpert: boolean;
  getProfile: (userId: string | number) => Promise<User | undefined>;
}

const AuthContext = createContext({} as AuthContextApi);

export default AuthContext;
